// Supabase browser client singleton. One instance per app load.
//
// Env-driven so the same build can target localhost (anon dev key) or
// production simplestruct.com. Vite exposes import.meta.env.VITE_*.
//
// If env is missing we still create a client pointing at a placeholder so
// the rest of the app type-checks; the network calls will fail loudly when
// a user actually tries to sign in or fetch entitlement. That's the right
// failure mode for a freshly-cloned repo with no .env.local yet.

import { createClient, SupabaseClient } from '@supabase/supabase-js';

const url  = import.meta.env.VITE_SUPABASE_URL  ?? 'https://idn.simplestruct.com';
// Non-empty placeholder so createClient does not throw on a fresh clone with
// no .env.local. Network calls still 401, which is the right failure mode for
// a missing VITE_SUPABASE_ANON_KEY — but the rest of the app boots and the
// ErrorBoundary fallback can render. CV-773.
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY ?? 'placeholder.anon.key.not-real';

export const supabase: SupabaseClient = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});

export const SUPABASE_FN_URL = `${url.replace(/\/+$/, '')}/functions/v1`;
